export default __webpack_public_path__ + "static/media/out-of-time.1053b0ea.png";